import React, {
	createContext,
	useState,
	useContext,
	useEffect,
	useCallback,
} from "react";
import { userManager } from "./auth-config";
import { clearAvatarImageCache } from "./avatarImageCache";
import { clearMRNotesCache } from "./hooks/useMRNotes";
import { clearMergeRequestDiffCache } from "./hooks/useMergeRequestDiff";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		userManager.getUser().then((user) => {
			setUser(user);
			setLoading(false);
		});

		const handleUserLoaded = (user) => setUser(user);
		const handleUserUnloaded = () => {
			clearAvatarImageCache();
			clearMRNotesCache();
			clearMergeRequestDiffCache();
			setUser(null);
		};

		userManager.events.addUserLoaded(handleUserLoaded);
		userManager.events.addUserUnloaded(handleUserUnloaded);

		return () => {
			userManager.events.removeUserLoaded(handleUserLoaded);
			userManager.events.removeUserUnloaded(handleUserUnloaded);
		};
	}, []);

	const login = useCallback(async () => {
		try {
			await userManager.signinRedirect();
		} catch (error) {
			console.error("Login error:", error);
			throw error;
		}
	}, []);

	const logout = useCallback(async () => {
		try {
			await userManager.removeUser();
			clearAvatarImageCache();
			clearMRNotesCache();
			clearMergeRequestDiffCache();
			setUser(null);
		} catch (error) {
			console.error("Logout error:", error);
		}
	}, []);

	return (
		<AuthContext.Provider value={{ user, login, logout, loading }}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
